"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectSubscriptionQty = exports.selectSubscriptionProcess = exports.selectSubscriptionPlanLoading = exports.selectSubscriptionModalOpened = exports.selectSubscriptionModalPostData = exports.selectSubscriptionPlanData = exports.subscriptionPlansData = exports.closeSubscriptionModal = exports.setSubscription = exports.getSubscriptionPlan = exports.setSubscriptionQty = exports.subscriptionModalClosed = exports.getSubscriptionPostData = exports.getPlansFailed = exports.getPlanSuccess = exports.getPlansSuccess = exports.getPlansAttempt = exports.subscribeFailed = exports.subscribeSuccess = exports.subscribeAttempt = exports.subscribeSlice = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var axios_1 = __importDefault(require("axios"));
var initialState = {
    planLoading: false,
    subscriptionProcess: false,
    subscribePlans: [],
    subscriptionPlan: null,
    subscriptionModalPostData: null,
    subscriptionModalOpened: false,
    subscriptionQty: 1,
};
exports.subscribeSlice = toolkit_1.createSlice({
    name: 'subscription',
    initialState: initialState,
    reducers: {
        subscribeAttempt: function (state) {
            state.subscriptionProcess = true;
        },
        subscribeSuccess: function (state) {
            state.subscriptionProcess = false;
        },
        subscribeFailed: function (state) {
            state.subscriptionProcess = false;
        },
        getPlansAttempt: function (state) {
            state.planLoading = true;
        },
        getPlansSuccess: function (state, action) {
            state.planLoading = false;
            state.subscribePlans = action.payload;
            state.subscriptionProcess = false;
        },
        getPlanSuccess: function (state, action) {
            state.planLoading = false;
            state.subscriptionPlan = action.payload;
            state.subscriptionProcess = false;
        },
        getPlansFailed: function (state) {
            state.planLoading = false;
        },
        getSubscriptionPostData: function (state, action) {
            state.subscriptionModalPostData = action.payload;
            state.subscriptionModalOpened = true;
        },
        subscriptionModalClosed: function (state) {
            state.subscriptionModalOpened = false;
            state.subscriptionPlan = null;
            state.subscriptionModalPostData = null;
        },
        setSubscriptionQty: function (state, action) {
            state.subscriptionQty = action.payload;
        },
    },
});
exports.subscribeAttempt = (_a = exports.subscribeSlice.actions, _a.subscribeAttempt), exports.subscribeSuccess = _a.subscribeSuccess, exports.subscribeFailed = _a.subscribeFailed, exports.getPlansAttempt = _a.getPlansAttempt, exports.getPlansSuccess = _a.getPlansSuccess, exports.getPlanSuccess = _a.getPlanSuccess, exports.getPlansFailed = _a.getPlansFailed, exports.getSubscriptionPostData = _a.getSubscriptionPostData, exports.subscriptionModalClosed = _a.subscriptionModalClosed, exports.setSubscriptionQty = _a.setSubscriptionQty;
var getSubscriptionPlan = function (subscriptionPlan, postData) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var data, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(exports.getPlansAttempt());
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, , 6]);
                    return [4 /*yield*/, axios_1.default.get("/api/subscription-plan/" + subscriptionPlan + "/post/" + postData.id)];
                case 2:
                    data = (_a.sent()).data;
                    return [4 /*yield*/, dispatch(exports.getPlanSuccess(data))];
                case 3:
                    _a.sent();
                    return [4 /*yield*/, dispatch(exports.getSubscriptionPostData(postData))];
                case 4:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 5:
                    e_1 = _a.sent();
                    dispatch(exports.getPlansFailed());
                    throw e_1;
                case 6: return [2 /*return*/];
            }
        });
    }); };
};
exports.getSubscriptionPlan = getSubscriptionPlan;
var setSubscription = function (subscriptionData) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var subscriptionPlanId, payment_bank, currency, post_id, subscriptionQty, data, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!subscriptionData) {
                    return [2 /*return*/];
                }
                subscriptionPlanId = subscriptionData.subscriptionPlanId, payment_bank = subscriptionData.payment_bank, currency = subscriptionData.currency, post_id = subscriptionData.post_id, subscriptionQty = subscriptionData.subscriptionQty;
                dispatch(exports.subscribeAttempt());
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, axios_1.default.get("/api/get-payment-form?subscription_plan_id=" + subscriptionPlanId + "&payment_bank=" + payment_bank + "&currency=" + currency + "&post_id=" + post_id + "&qty=" + subscriptionQty)];
            case 2:
                data = (_a.sent()).data;
                dispatch(exports.subscribeSuccess());
                return [2 /*return*/, data];
            case 3:
                e_2 = _a.sent();
                dispatch(exports.subscribeFailed());
                throw e_2;
            case 4: return [2 /*return*/];
        }
    });
}); }; };
exports.setSubscription = setSubscription;
var closeSubscriptionModal = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        dispatch(exports.subscriptionModalClosed());
        return [2 /*return*/];
    });
}); }; };
exports.closeSubscriptionModal = closeSubscriptionModal;
var subscriptionPlansData = function (state) {
    return state.subscription.subscribePlans;
};
exports.subscriptionPlansData = subscriptionPlansData;
var selectSubscriptionPlanData = function (state) {
    return state.subscription.subscriptionPlan;
};
exports.selectSubscriptionPlanData = selectSubscriptionPlanData;
var selectSubscriptionModalPostData = function (state) {
    return state.subscription.subscriptionModalPostData;
};
exports.selectSubscriptionModalPostData = selectSubscriptionModalPostData;
var selectSubscriptionModalOpened = function (state) {
    return state.subscription.subscriptionModalOpened;
};
exports.selectSubscriptionModalOpened = selectSubscriptionModalOpened;
var selectSubscriptionPlanLoading = function (state) {
    return state.subscription.planLoading;
};
exports.selectSubscriptionPlanLoading = selectSubscriptionPlanLoading;
var selectSubscriptionProcess = function (state) {
    return state.subscription.subscriptionProcess;
};
exports.selectSubscriptionProcess = selectSubscriptionProcess;
var selectSubscriptionQty = function (state) {
    return state.subscription.subscriptionQty;
};
exports.selectSubscriptionQty = selectSubscriptionQty;
exports.default = exports.subscribeSlice.reducer;
